var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "b-modal",
        {
          ref: "modal_invoice_tasks_select",
          attrs: {
            id: "modal-invoice-tasks",
            title: _vm.title,
            "content-class": "modal-fullscreen",
            "body-class": "modal-body-fullscreen",
            "modal-class": "custom-modal",
            "no-close-on-esc": "",
            "no-close-on-backdrop": "",
            scrollable: ""
          },
          scopedSlots: _vm._u([
            {
              key: "modal-footer",
              fn: function() {
                return [
                  _c(
                    "div",
                    { staticClass: "w-100 d-flex justify-content-end" },
                    [
                      _c("h6", [
                        _vm._v(
                          "Будут добавлены: " + _vm._s(_vm.selected.length)
                        )
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "vr" }),
                      _vm._v(" "),
                      _c("h6", [
                        _vm._v(
                          "Уже в добавлены: " + _vm._s(_vm.invoiceTasks.length)
                        )
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "vr" }),
                      _vm._v(" "),
                      _c(
                        "b-button",
                        {
                          staticClass: "custom-btn-secondary mr-2",
                          on: { click: _vm.hideModal }
                        },
                        [_vm._v("\n          Отменить\n        ")]
                      ),
                      _vm._v(" "),
                      _c(
                        "b-button",
                        {
                          staticClass: "custom-btn-primary",
                          attrs: { disabled: _vm.isBusy },
                          on: { click: _vm.rowClickHandler }
                        },
                        [_vm._v("\n          Добавить в счёт\n        ")]
                      )
                    ],
                    1
                  )
                ]
              },
              proxy: true
            }
          ])
        },
        [
          _c(
            "b-row",
            { staticClass: "mb-0" },
            [
              _c(
                "b-col",
                { attrs: { cols: "10" } },
                [
                  _c("b-form", [
                    _c(
                      "div",
                      { staticClass: "page-body" },
                      [
                        _vm.isBusy || (_vm.items && _vm.items.length > 0)
                          ? [
                              _c(
                                "div",
                                { staticClass: "page-table-container" },
                                [
                                  _c("b-table", {
                                    staticClass: "custom-table text-small mb-0",
                                    attrs: {
                                      id: "invoice-tasks",
                                      responsive: "",
                                      busy: _vm.isBusy,
                                      items: _vm.items,
                                      fields: _vm.fields,
                                      "tbody-tr-class": _vm.tbodyRowClass,
                                      "no-provider-filtering": "",
                                      "no-provider-paging": "",
                                      "no-provider-sorting": ""
                                    },
                                    on: { "row-clicked": _vm.rowClicked },
                                    scopedSlots: _vm._u(
                                      [
                                        {
                                          key: "head(selected)",
                                          fn: function(row) {
                                            return [
                                              _c("b-form-checkbox", {
                                                staticClass: "mx-1",
                                                attrs: {
                                                  checked: _vm.allSelected,
                                                  indeterminate:
                                                    _vm.indeterminate,
                                                  disabled:
                                                    _vm.allSelectDisabled,
                                                  size: "md"
                                                },
                                                on: {
                                                  change: _vm.selectAllRows
                                                }
                                              })
                                            ]
                                          }
                                        },
                                        {
                                          key: "cell(selected)",
                                          fn: function(row) {
                                            return [
                                              row.item.selected
                                                ? [
                                                    _c(
                                                      "span",
                                                      {
                                                        attrs: {
                                                          "aria-hidden": "true"
                                                        }
                                                      },
                                                      [_vm._v("✓")]
                                                    ),
                                                    _vm._v(" "),
                                                    _c(
                                                      "span",
                                                      {
                                                        staticClass: "sr-only"
                                                      },
                                                      [_vm._v("Выбрана")]
                                                    )
                                                  ]
                                                : [
                                                    _c("span", [_vm._v(" ")]),
                                                    _vm._v(" "),
                                                    _c(
                                                      "span",
                                                      {
                                                        staticClass: "sr-only"
                                                      },
                                                      [_vm._v("Не выбрана")]
                                                    )
                                                  ]
                                            ]
                                          }
                                        },
                                        {
                                          key: "cell(start_address)",
                                          fn: function(row) {
                                            return [
                                              row.item.start_address.length < 50
                                                ? _c("div", [
                                                    _vm._v(
                                                      _vm._s(
                                                        row.item.start_address
                                                      )
                                                    )
                                                  ])
                                                : _c("div", [
                                                    _vm._v(
                                                      _vm._s(
                                                        row.item.start_address.substring(
                                                          0,
                                                          50
                                                        ) + ".."
                                                      )
                                                    )
                                                  ])
                                            ]
                                          }
                                        },
                                        {
                                          key: "cell(start_date)",
                                          fn: function(row) {
                                            return [
                                              _vm._v(
                                                "\n                    " +
                                                  _vm._s(
                                                    _vm.formatTableDateTime(
                                                      row.item.start_date
                                                    )
                                                  ) +
                                                  "\n                  "
                                              )
                                            ]
                                          }
                                        },
                                        {
                                          key: "cell(total_price)",
                                          fn: function(row) {
                                            return [
                                              _vm._v(
                                                "\n                    " +
                                                  _vm._s(
                                                    _vm.priceFormat(
                                                      row.item.total_price
                                                    )
                                                  ) +
                                                  "\n                  "
                                              )
                                            ]
                                          }
                                        },
                                        {
                                          key: "cell(status_id)",
                                          fn: function(row) {
                                            return [
                                              _c(
                                                "div",
                                                {
                                                  staticStyle: {
                                                    "font-size": "medium"
                                                  }
                                                },
                                                [
                                                  _c(
                                                    "b-badge",
                                                    {
                                                      attrs: {
                                                        pill: "",
                                                        variant: _vm.getStatusStyle(
                                                          row.item.status_id
                                                        )
                                                      }
                                                    },
                                                    [
                                                      _vm._v(
                                                        "\n                        " +
                                                          _vm._s(
                                                            _vm.getStatusName(
                                                              row.item.status_id
                                                            )
                                                          ) +
                                                          "\n                      "
                                                      )
                                                    ]
                                                  )
                                                ],
                                                1
                                              )
                                            ]
                                          }
                                        },
                                        {
                                          key: "cell(paid_workers)",
                                          fn: function(row) {
                                            return [
                                              _c("font-awesome-icon", {
                                                style: _vm.paidWorkers(row)
                                                  .style,
                                                attrs: {
                                                  icon: [
                                                    "fas",
                                                    _vm.paidWorkers(row).icon
                                                  ]
                                                }
                                              })
                                            ]
                                          }
                                        },
                                        {
                                          key: "cell(paid)",
                                          fn: function(row) {
                                            return [
                                              _vm._v(
                                                "\n                    " +
                                                  _vm._s(_vm.paid(row)) +
                                                  "\n                  "
                                              )
                                            ]
                                          }
                                        },
                                        {
                                          key: "cell(read_only)",
                                          fn: function(row) {
                                            return [
                                              _c("font-awesome-icon", {
                                                style: _vm.readOnly(row).style,
                                                attrs: {
                                                  icon: [
                                                    "fas",
                                                    _vm.readOnly(row).icon
                                                  ]
                                                }
                                              })
                                            ]
                                          }
                                        }
                                      ],
                                      null,
                                      false,
                                      570756442
                                    )
                                  })
                                ],
                                1
                              )
                            ]
                          : _vm._e(),
                        _vm._v(" "),
                        _c("pagination-footer", {
                          attrs: {
                            "total-rows": _vm.totalRows,
                            "per-page": _vm.perPage
                          },
                          on: {
                            "update:perPage": function($event) {
                              _vm.perPage = $event
                            },
                            "update:per-page": function($event) {
                              _vm.perPage = $event
                            },
                            "page-click": _vm.onPagination
                          },
                          scopedSlots: _vm._u([
                            {
                              key: "footer-list",
                              fn: function() {
                                return [
                                  _c("div", [
                                    _vm._v(
                                      "\n                  Всего заявок: "
                                    ),
                                    _c("b", [_vm._v(_vm._s(_vm.totalRows))])
                                  ])
                                ]
                              },
                              proxy: true
                            },
                            {
                              key: "footer-buttons",
                              fn: function() {
                                return [
                                  _c("b-pagination", {
                                    attrs: {
                                      pills: "",
                                      "total-rows": _vm.totalRows,
                                      "per-page": _vm.perPage
                                    },
                                    on: { "page-click": _vm.onPagination },
                                    model: {
                                      value: _vm.currentPage,
                                      callback: function($$v) {
                                        _vm.currentPage = $$v
                                      },
                                      expression: "currentPage"
                                    }
                                  })
                                ]
                              },
                              proxy: true
                            }
                          ])
                        })
                      ],
                      2
                    )
                  ])
                ],
                1
              ),
              _vm._v(" "),
              _c("b-col", { attrs: { cols: "2" } }, [
                _c(
                  "div",
                  {
                    staticClass: "mr-1",
                    staticStyle: { position: "sticky", top: "0" }
                  },
                  [
                    _c(
                      "b-row",
                      { staticClass: "mb-2" },
                      [
                        _c(
                          "b-input-group",
                          [
                            _c("b-form-input", {
                              attrs: {
                                size: "sm",
                                placeholder: _vm.$t("message.common.search")
                              },
                              on: { input: _vm.onQueryChange },
                              model: {
                                value: _vm.query,
                                callback: function($$v) {
                                  _vm.query = $$v
                                },
                                expression: "query"
                              }
                            }),
                            _vm._v(" "),
                            _c(
                              "b-input-group-append",
                              [
                                _c(
                                  "b-btn",
                                  {
                                    attrs: { size: "sm", variant: "info" },
                                    on: {
                                      click: function($event) {
                                        $event.stopPropagation()
                                        return _vm.onSearch()
                                      }
                                    }
                                  },
                                  [
                                    _c("font-awesome-icon", {
                                      attrs: { icon: "search" }
                                    }),
                                    _vm._v(" Найти\n                ")
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c(
                                  "b-btn",
                                  {
                                    attrs: {
                                      disabled: _vm.query.length === 0,
                                      size: "sm",
                                      variant: "secondary"
                                    },
                                    on: {
                                      click: function($event) {
                                        $event.stopPropagation()
                                        return _vm.clearSearch()
                                      }
                                    }
                                  },
                                  [
                                    _c("font-awesome-icon", {
                                      attrs: { icon: "times-circle" }
                                    })
                                  ],
                                  1
                                )
                              ],
                              1
                            )
                          ],
                          1
                        )
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "b-row",
                      [
                        _c(
                          "b-form-group",
                          {
                            staticClass: "w-100",
                            attrs: {
                              id: "group_town",
                              label: "Город",
                              "label-for": "input_town"
                            }
                          },
                          [
                            _c(
                              "b-form-select",
                              {
                                attrs: { size: "sm", id: "input_town" },
                                on: {
                                  change: function($event) {
                                    return _vm.onTownChange()
                                  }
                                },
                                model: {
                                  value: _vm.currentTown,
                                  callback: function($$v) {
                                    _vm.currentTown = $$v
                                  },
                                  expression: "currentTown"
                                }
                              },
                              [
                                _c("option", { domProps: { value: -1 } }, [
                                  _vm._v("Все города")
                                ]),
                                _vm._v(" "),
                                _vm._l(_vm.towns, function(option) {
                                  return _c(
                                    "option",
                                    { domProps: { value: option.id } },
                                    [
                                      _vm._v(
                                        "\n                  " +
                                          _vm._s(option.name) +
                                          "\n                "
                                      )
                                    ]
                                  )
                                })
                              ],
                              2
                            )
                          ],
                          1
                        )
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "b-row",
                      [
                        _c(
                          "b-form-group",
                          { attrs: { id: "group_location", label: "Объекты" } },
                          [
                            _c("location-multi-select", {
                              ref: "location_multi_select",
                              attrs: {
                                id: "location-multi-select",
                                "start-date": _vm.startDate,
                                "end-date": _vm.endDate,
                                "show-date-button": true
                              },
                              on: { onSelect: _vm.onSelectLocation }
                            })
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "b-form-group",
                          {
                            attrs: {
                              id: "group_customer",
                              label: _vm.$t("message.tasks.modal.customer"),
                              "label-for": "input_customer"
                            }
                          },
                          [
                            _c(
                              "b-input-group",
                              [
                                _c("b-form-input", {
                                  attrs: {
                                    id: "input_customer",
                                    type: "text",
                                    size: "sm",
                                    readonly: "",
                                    placeholder: _vm.$t(
                                      "message.tasks.modal.customerPlaceholder"
                                    )
                                  },
                                  model: {
                                    value: _vm.customer.name,
                                    callback: function($$v) {
                                      _vm.$set(_vm.customer, "name", $$v)
                                    },
                                    expression: "customer.name"
                                  }
                                }),
                                _vm._v(" "),
                                _c(
                                  "b-input-group-append",
                                  [
                                    _c(
                                      "b-btn",
                                      {
                                        attrs: {
                                          size: "sm",
                                          variant: "outline-success"
                                        },
                                        on: {
                                          click: function($event) {
                                            $event.stopPropagation()
                                            return _vm.showCustomerTable()
                                          }
                                        }
                                      },
                                      [_vm._v("Выбрать")]
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "b-btn",
                                      {
                                        attrs: {
                                          disabled: _vm.customer.id === 0,
                                          size: "sm",
                                          variant: "secondary"
                                        },
                                        on: {
                                          click: function($event) {
                                            $event.stopPropagation()
                                            return _vm.removeCustomer()
                                          }
                                        }
                                      },
                                      [
                                        _c("font-awesome-icon", {
                                          attrs: { icon: "times-circle" }
                                        })
                                      ],
                                      1
                                    )
                                  ],
                                  1
                                )
                              ],
                              1
                            )
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "b-form-group",
                          {
                            staticClass: "w-100",
                            attrs: {
                              id: "group_paid",
                              label: "Оплачено",
                              "label-for": "input_paid"
                            }
                          },
                          [
                            _c("b-form-select", {
                              attrs: {
                                id: "input_paid",
                                size: "sm",
                                options: _vm.filterPaidTypes
                              },
                              on: { change: _vm.onSearch },
                              model: {
                                value: _vm.filterPaid,
                                callback: function($$v) {
                                  _vm.filterPaid = $$v
                                },
                                expression: "filterPaid"
                              }
                            })
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "b-form-group",
                          {
                            staticClass: "w-100",
                            attrs: {
                              id: "group_executor",
                              label: "Менеджер",
                              "label-for": "input_executor"
                            }
                          },
                          [
                            _c(
                              "b-form-select",
                              {
                                attrs: { id: "input_executors", size: "sm" },
                                on: {
                                  change: function($event) {
                                    return _vm.onSearch()
                                  }
                                },
                                model: {
                                  value: _vm.executor_id,
                                  callback: function($$v) {
                                    _vm.executor_id = $$v
                                  },
                                  expression: "executor_id"
                                }
                              },
                              [
                                _c("option", { domProps: { value: 0 } }, [
                                  _vm._v("Все")
                                ]),
                                _vm._v(" "),
                                _vm._l(_vm.activeExecutors, function(option) {
                                  return _c(
                                    "option",
                                    { domProps: { value: option.id } },
                                    [
                                      _vm._v(
                                        "\n                " +
                                          _vm._s(option.name) +
                                          "\n              "
                                      )
                                    ]
                                  )
                                })
                              ],
                              2
                            )
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "b-form-group",
                          {
                            attrs: {
                              id: "group_start_date",
                              label: "Дата начала с",
                              "label-for": "input_start_date"
                            }
                          },
                          [
                            _c("b-form-input", {
                              attrs: {
                                size: "sm",
                                id: "input_start_date",
                                type: "date"
                              },
                              on: {
                                change: function($event) {
                                  return _vm.onSearch()
                                }
                              },
                              model: {
                                value: _vm.startDate,
                                callback: function($$v) {
                                  _vm.startDate = $$v
                                },
                                expression: "startDate"
                              }
                            })
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "b-form-group",
                          {
                            staticClass: "pl-2",
                            attrs: {
                              id: "group_end_date",
                              label: "по",
                              "label-for": "input_end_date"
                            }
                          },
                          [
                            _c("b-form-input", {
                              attrs: {
                                size: "sm",
                                id: "input_end_date",
                                type: "date"
                              },
                              on: {
                                change: function($event) {
                                  return _vm.onSearch()
                                }
                              },
                              model: {
                                value: _vm.endDate,
                                callback: function($$v) {
                                  _vm.endDate = $$v
                                },
                                expression: "endDate"
                              }
                            })
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "b-form-group",
                          {
                            attrs: {
                              id: "group_statuses",
                              label: "Статус заявки",
                              "label-for": "input_statuses"
                            }
                          },
                          [
                            _c(
                              "b-form-select",
                              {
                                staticClass: "mb-1 mr-2",
                                attrs: { id: "input_statuses", size: "sm" },
                                on: {
                                  change: function($event) {
                                    return _vm.onSearch()
                                  }
                                },
                                model: {
                                  value: _vm.status_id,
                                  callback: function($$v) {
                                    _vm.status_id = $$v
                                  },
                                  expression: "status_id"
                                }
                              },
                              [
                                _c("option", { domProps: { value: 0 } }, [
                                  _vm._v("Все статусы")
                                ]),
                                _vm._v(" "),
                                _vm._l(_vm.statuses, function(option) {
                                  return _c(
                                    "option",
                                    { domProps: { value: option.id } },
                                    [
                                      _vm._v(
                                        "\n                  " +
                                          _vm._s(option.name) +
                                          "\n                "
                                      )
                                    ]
                                  )
                                })
                              ],
                              2
                            )
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "b-form-group",
                          {
                            attrs: {
                              id: "group_statuses",
                              label: "Оплачено исполнителям",
                              "label-for": "input_statuses"
                            }
                          },
                          [
                            _c(
                              "b-form-select",
                              {
                                staticClass: "mb-1 mr-2",
                                attrs: {
                                  id: "input_paid_workers_statuses",
                                  size: "sm"
                                },
                                on: {
                                  change: function($event) {
                                    return _vm.onSearch()
                                  }
                                },
                                model: {
                                  value: _vm.paid_workers_status_id,
                                  callback: function($$v) {
                                    _vm.paid_workers_status_id = $$v
                                  },
                                  expression: "paid_workers_status_id"
                                }
                              },
                              [
                                _c("option", { domProps: { value: 0 } }, [
                                  _vm._v("Все статусы оплаты")
                                ]),
                                _vm._v(" "),
                                _vm._l(_vm.paidWorkersStatuses, function(
                                  option
                                ) {
                                  return _c(
                                    "option",
                                    { domProps: { value: option.id } },
                                    [
                                      _vm._v(
                                        "\n                  " +
                                          _vm._s(option.name) +
                                          "\n                "
                                      )
                                    ]
                                  )
                                })
                              ],
                              2
                            )
                          ],
                          1
                        )
                      ],
                      1
                    )
                  ],
                  1
                )
              ])
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _c("customer-table-select", {
        ref: "customerTable",
        attrs: { town: 0 },
        on: { selectCustomer: _vm.updateCustomer }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-75093cb4", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-75093cb4","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Invoices/InvoiceTasksSelect.vue
// module id = null
// module chunks = 